import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5010Class } from '../../CSPClass/CSP5010/csp5010-class';
import { environment } from '../../../../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Csp5010Service {

    baseUrl: string=  environment.baseUrlCsp + 'CSP5010/';
    constructor(private http:HttpClient) { }

  Profile(Csp5010Class:Csp5010Class):Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'Profile',Csp5010Class);
  }
    LoadImage(Csp5010Class:Csp5010Class):Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'LoadImage',Csp5010Class);
  }
  
}
